module.exports = __webpack_public_path__ + "static/media/hugo-boss-just-different-big.18c31899.png";